import React, { Component } from 'react';
//import { Button } from 'react-bootstrap';

import './vheader.css';

//import FontAwesome from 'font-awesome';

class vheader extends Component {
  constructor(){
    super();
    this.state = {
      adverts:[
           {
            title: 'Advert Title'
           }
        ]
    }
  }

// componentWillMount(){
//   this.setState({advert:[
//     {
//       title: 'Advert Title'
//     }
//   ]});
// }

render() {
      return (
        <header>
        <div id='logo'/>
        </header>
      );
    }
}

export default vheader;



// WEBPACK FOOTER //
// ./src/components/vheader.js